import { cmsAdminApiUrl } from 'lib/url'

export interface EventPost {
  id: number
  title: {
    rendered: string
  }
  date: string
  start_date?: string
  end_date?: string
  thumbnail_img?: string
}

const toThumbnailUrl = (thumbnail?: string): string | undefined => {
  if (!thumbnail) {
    return thumbnail
  }

  const sitePath = thumbnail
    .split('https://cms-admin.i3design.jp/wp-content/uploads')
    .join('/images/wp')

  // ローカル dev には /images/wp が無いため、本番 CDN の URL を使う
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return `https://www.i3design.jp${sitePath}`
  }

  return sitePath
}

export async function fetchActiveEvents(): Promise<EventPost[]> {
  try {
    const response = await fetch(`${cmsAdminApiUrl}/wp/v2/posts?categories=3&per_page=100`)
    if (!response.ok) {
      return []
    }

    const posts: EventPost[] = await response.json()
    const currentDate = new Date().toISOString()

    return posts
      .filter((post) => post.end_date && new Date(post.end_date).toISOString() >= currentDate)
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      .map((event) => ({
        ...event,
        thumbnail_img: toThumbnailUrl(event.thumbnail_img),
      }))
  } catch (error) {
    console.error('Error fetching events:', error)
    return []
  }
}
